<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import store from '@/store';
import hasPermission from '@/helpers/hasPermission';

/* eslint-disable */
export default {
  async beforeRouteEnter(to, from, next) {
    await store.commit('global/setRole', null, { root: true });

    if (
      hasPermission('investor_car_accident_view') &&
      store.getters['global/getRole'] === 'investor'
    ) {
      next();
    } else {
      next('/workers-board');
    }
  },
};
</script>

<style></style>
